import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReceiptDescriptions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/receipt_descriptions", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchReceiptDescription(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/receipt_descriptions/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editReceiptDescription(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/receipt_descriptions", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteReceiptDescription(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/receipt_descriptions", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
